import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { copyEn } from '../data/copyEn';
import { copyEs } from '../data/copyEs';
import type { Copy, Lang } from '../types/copy';
interface LanguageValue {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: Copy;
}
const STORAGE_KEY = 'alma-yoga-lang';
const LanguageContext = createContext<LanguageValue | null>(null);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLang] = useState<Lang>(readInitialLang);
  useEffect(() => {
    document.documentElement.lang = lang;
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // storage unavailable — preference simply won't persist
    }
  }, [lang]);
  const value = useMemo<LanguageValue>(() => ({
    lang,
    setLang,
    t: lang === 'es' ? copyEs : copyEn
  }), [lang]);
  return <LanguageContext.Provider value={value} data-id="element-386" data-mp="2jkyepecqzvzk">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageValue {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used inside LanguageProvider');
  return ctx;
}
function readInitialLang(): Lang {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'es') return stored;
  } catch {
    // ignore
  }
  return 'en';
}